import download from './download/index';

const path = '/company';

const company = (url: string) => () => ({
  download: download(`${url}${path}`)
})

export default company;